import { components } from "react-select";

export const Option = ({ children, ...props }) => {
    props.className = "option-select-custom";

    return <components.Option {...props}>{children}</components.Option>;
};

export const NoOptionsMessage = ({ children, ...rest }) => (
    <components.NoOptionsMessage {...rest}>
        <span>No hay datos</span>
    </components.NoOptionsMessage>
);
